import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SharingDataService } from 'src/app/Services/sharing-data.service';

@Component({
  selector: 'app-gipReqResetForm',
  templateUrl: './gipReqResetForm.component.html',
  styleUrls: ['./gipReqResetForm.component.css']
})
export class GipReqResetFormComponent implements OnInit {

  constructor(private shareData: SharingDataService) { }

  formular = [
    { formControlName: "G3EFID_FILTER", visible: true, required: false, readonly: true, textArea: true },
    { formControlName: "PROCESSING_STATE_FILTER", visible: true, picklist:"MS_PROCESSING_STATE_VL_T", required: false, readonly: false},

  ]

  modelInput = new FormGroup({
    G3EFID_FILTER: new FormControl(),
    PROCESSING_STATE_FILTER: new FormControl(),
  });

  resourceDefinition;
  
  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
  }

}
